import { environment } from '@env/environment';

/**
 * Build absolute URL for a file under the backend upload root.
 * The API serves UPLOAD_DIRECTORY at the server root (not under /uploads).
 */
export function uploadAssetUrl(relativePath: string): string {
  const raw = String(relativePath || '')
    .trim()
    .replace(/^[/\\]+/, '');
  const base = ((environment as any).uploadsBaseUrl || environment.baseUrl || '').replace(/\/$/, '');
  if (!raw) return base;
  const encoded = raw
    .split(/[/\\]+/)
    .filter(Boolean)
    .map((seg) => encodeURIComponent(seg))
    .join('/');
  return `${base}/${encoded}`;
}
